import React, { Component } from 'react';

import FileDownLoadButton from '../common/FileDownloadButton';
import FileUpload from '../common/FileUpload';
import SimpleReactValidator from 'simple-react-validator';
import { InlineLoading, Button, Table, TableContainer, TableHead, TableHeader, TableBody, TableRow, TableCell, ComposedModal, ModalHeader, ModalBody, TableToolbar, FormGroup, Icon, } from 'carbon-components-react'; 
import { ComboBox } from '../../helpers/ComboBox';
import { Delete16, Add16, Download16, Renew16 } from '@carbon/icons-react';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { Online, Offline } from '../common/OnLineOffLine';
import { api } from '../../helpers/api/api';
import { getError, entitiesLabels, apioperation } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { v4 as uuid } from 'uuid';

const attachmentTypes = ['Pictures','Documents',];
const imageFileExtensions = ['jpeg', 'jpg', 'png', 'gif'];
const fileExtensions = ['bmp','pdf','docx','xlsx', 'pptx'];

export default class HocCardAttachments extends Component {
  // Initializers
  clearAttachment = () => ({
    id: null,
    fileIdentifier: null,
    name: null,
    contentType: null,
    size: null,
    type: null
  });
  initialState = props => ({
    idHocCard: props.idHocCard,
    attachment: this.clearAttachment(),
    attachmentTypes,
    key: `modalAtt_${new Date().getTime()}`,
    isOpenModal: false
  });

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      ...this.initialState(props)
    };
  }

  toggleModal = open => {
    this.setState({ isOpenModal: open, attachmentTypes: attachmentTypes });
  };

  addAttachment = () => {
    this.setState({ key: `modalAtt_${new Date().getTime()}`, isOpenModal: true });
  };

  downloadAttachment = async item => {
    try {
      const file = await api.getBlob(
        `/hoccard/${this.state.idHocCard}/attachment${item.attachment.fileIdentifier}`
      ).data;
      return this.downloadFile(file, item.attachment.name);
    } catch (error) {
      return showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FileUpload, apioperation.GET));
    }
  };

  downloadFile = (blob, fileName) => {
    if (navigator.msSaveBlob)
      navigator.msSaveBlob(blob, fileName);
    else {
      const link = document.createElement('a');
      // Browsers that support HTML5 download attribute
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  updateState = (inputName, inputValue, objName) => {
    const stateCopy = { ...this.state };
    stateCopy[objName][inputName] = inputValue;
    this.setState(stateCopy);
  };

  onUpload = (fileIdentifier, fileName, fileType, size) => {
    const last = fileName.split('.').pop();
    if (this.state.attachment.type === 'Pictures' && !imageFileExtensions.includes(last.toLowerCase()))
        return showNotification.warning(`${entitiesLabels.WARNING}`, "This format cannot be accepted");
    if (this.state.attachment.type === 'Documents' && !fileExtensions.includes(last.toLowerCase())) {
    return showNotification.warning(`${entitiesLabels.WARNING}`, "This format cannot be accepted")
    }
    else {
      const attachment = { ...this.state.attachment };

      attachment.id = uuid();
      attachment.fileIdentifier = fileIdentifier.blobName;
      attachment.name = fileName;
      attachment.contentType = fileType;
      attachment.size = size;

      this.toggleModal(false);
      this.setState({ attachment: this.clearAttachment() });
      return this.props.addNewAttachment(attachment);
    }
  };

  remove = id => {
    this.props.removeAttachment(id);
  };

  render() {
    const validations = {
      type: this.validator.message('type', this.state.attachment.type, 'required'),
      file: this.validator.message('type', this.state.attachment.id, 'required')
    };
    const rows = this.props.attachments || [];

    const modalHeader = {
      title: 'Add new',
      iconDescription: 'Close',
      buttonClick: () => this.toggleModal(false)
    };

    return (
      <>
        <div className="bx--row">
          <div className="bx--col-lg-12">
            <TableToolbar>
              <h3 className="title--medium max-width" />
              {!this.props.isDisabled && (
                <Button
                  onClick={() => this.addAttachment()}
                  renderIcon={Add16}
                >
                  Add new
                </Button>
              )}
            </TableToolbar>
            <TableContainer className="bx--grid--full-width">
              <Table>
                <TableHead className="colorgray">
                  <TableRow>
                    <TableHeader>Name</TableHeader>
                    <TableHeader>Type</TableHeader>
                    <TableHeader className="align-center">Actions</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows == null || rows.length === 0 ? (
                    <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                  ) : (
                    rows.map(item => (
                      <TableRow key={`row_${item.idAttachment}`}>
                        <TableCell key={`cell_1_${item.idAttachment}`}>{item.attachment.name}</TableCell>
                        <TableCell key={`cell_2_${item.idAttachment}`}>{item.attachment.type}</TableCell>
                        <TableCell key={`action-${item.idAttachment}`} className="tableActions align-center">
                          <div>
                            <Online>
                              {item.loading ?
                                <InlineLoading className="inline-action-loading" />
                                  :
                                item.synching ?
                                  <Button 
                                    onClick={() => this.props.onAttachmentSync(item.idAttachment)}
                                    size="small"
                                    renderIcon={Renew16}
                                    iconDescription="Check for availability"
                                    kind="ghost"
                                  />
                                    :
                                  <FileDownLoadButton
                                    onError={error => {
                                      showNotification.error(`${entitiesLabels.ERROR}`,
                                        getError(error, entitiesLabels.HOCCARD, apioperation.DOWNLOAD));
                                    }}
                                    size="small"
                                    renderIcon={Download16}
                                    iconDescription="Download"
                                    kind="ghost"
                                    apiUrl={`/hoccard/${this.state.idHocCard}/attachment/${item.attachment.fileIdentifier}`}
                                    fileName={item.attachment.name}
                                    onDownLoadStart={() => {}}
                                    onDownLoadEnd={() => {}}
                                  />
                              }
                              {!this.props.isDisabled && (
                                <Button
                                  onClick={() => this.remove(item.idAttachment)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                />
                              )}
                            </Online>
                            <Offline>
                               <FileDownLoadButton
                                disabled={true}
                                onError={error => {
                                  showNotification.error(`${entitiesLabels.ERROR}`,
                                    getError(error, entitiesLabels.HOCCARD, apioperation.DOWNLOAD));
                                }}
                                size="small"
                                renderIcon={Download16}
                                iconDescription="Download"
                                kind="ghost"
                                apiUrl={`/hoccard/${this.state.idHocCard}/attachment/${item.attachment.fileIdentifier}`}
                                fileName={item.attachment.name}
                                onDownLoadStart={() => {}}
                                onDownLoadEnd={() => {}}
                              />
                              {!this.props.isDisabled && (
                                <Button
                                  onClick={() => this.remove(item.idAttachment)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                  disabled= {true}
                                />
                              )}
                            </Offline>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <ComposedModal
          className="light-modal"
          open={this.state.isOpenModal}
          danger="false"
          onClose={() => this.toggleModal(false)}
        >
          <ModalHeader className="margin-modal" {...modalHeader}>
            <p>Attachment</p>
          </ModalHeader>
          <ModalBody className="margin-modal">
            {this.state.isOpenModal ? (
              <div className="bx--grid--full-width">
                <div className="bx--row">
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Attachment Type">
                      <ComboBox
                        id="type"
                        placeholder="Select"
                        name="type"
                        alt="attachment"
                        onChange={this.updateState}
                        itemToString={(item) => item || ''}
                        items={this.state.attachmentTypes}
                        invalid={validations.type != null}
                      />
                      {validations.type}
                    </FormGroup>
                  </div>
                  <div className="bx--col-lg-12 bx--col-md-12">
                    <FormGroup legendText="Choose file">
                      {this.state.attachment.type && (
                        <FileUpload
                          disabled={!this.state.attachment.type}
                          Container="saipem"
                          StoragePath="hoccard"
                          onUpload={this.onUpload}
                          accept={this.state.attachment.type.includes("Pictures") ? ['.jpeg', '.jpg', '.png', '.gif',] : this.state.attachment.type.includes("Documents") ? ['bmp', 'pdf', 'docx', 'xlsx', 'pptx',]: null}
                          acceptDescription = {this.state.attachment.type.includes("Pictures")  ? 'only jpeg, jpg, png, gif files at 8mb or less' : 'only bmp, pdf, docx, xlsx, pptx files at 8mb or less'}
                        />
                      )}
                      {validations.file}
                    </FormGroup>
                  </div>
                </div>
              </div>
            ) : null}
          </ModalBody>

        </ComposedModal>
      </>
    )
  }

}